export const STALE_UPLOAD_THRESHOLD = 60000; // milliseconds

export const UPLOAD_STATUS = {
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  STALE: 'STALE',
  ABORTED: 'ABORTED',
  COMPLETED: 'COMPLETED',
} as const;

export class UploadUtils {
  public static progressVariant(uploadStatus: string): string {
    if (uploadStatus === UPLOAD_STATUS.PENDING) return 'info';
    if (uploadStatus === UPLOAD_STATUS.RUNNING) return 'primary';
    if (uploadStatus === UPLOAD_STATUS.STALE) return 'warning';
    if (uploadStatus === UPLOAD_STATUS.COMPLETED) return 'success';
    return 'danger';
  }

  public static canBeResumed(uploadStatus: string): boolean {
    return (
      uploadStatus === UPLOAD_STATUS.RUNNING ||
      uploadStatus === UPLOAD_STATUS.STALE ||
      uploadStatus === UPLOAD_STATUS.ABORTED
    );
  }

  public static canBeAborted(uploadStatus: string): boolean {
    return (
      uploadStatus === UPLOAD_STATUS.PENDING ||
      uploadStatus === UPLOAD_STATUS.RUNNING ||
      uploadStatus === UPLOAD_STATUS.STALE
    );
  }

  public static progressActive(uploadStatus: string): boolean {
    return (
      uploadStatus === UPLOAD_STATUS.PENDING ||
      uploadStatus === UPLOAD_STATUS.RUNNING ||
      uploadStatus === UPLOAD_STATUS.STALE
    );
  }
}
